import { THUMB_CARD_SIZE } from '../../../../../../../../const';

export const CARD_IMG_WIDTH = 272; // px, same in css (чтобы не нагружать подсчётами)
export const DRIVE_DOCS_IMGS_GOOGLE_THUMB_SIZE = `w${THUMB_CARD_SIZE}`;
